exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.futurebet-container {\n  width: 100%;\n}\n.futurebet-container .futurebet-info {\n    border-left: 4px solid #0066ae;\n    margin-bottom: 7px;\n}\n.futurebet-container .futurebet-info .futurebet-label {\n      width: 20%;\n      color: #fff;\n      margin-left: 10px;\n      font-weight: bold;\n}\n.futurebet-container .futurebet-boxes {\n    width: 100%;\n    display: inline-flex;\n}\n.futurebet-container .futurebet-boxes .futurebet-number {\n      margin-top: 15%;\n}\n.futurebet-container .futurebet-boxes .futurebet-box {\n      width: 9%;\n      height: 35px;\n      cursor: pointer;\n      margin-right: 5px;\n      color: #e6e6e6;\n      background-color: #424242;\n      text-align: center;\n      margin-bottom: 10px;\n}\n.futurebet-container .futurebet-boxes .is__active {\n      background-color: #685834;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-ee4435cc","scoped":false,"hasInlineConfig":false}!./~/sass-loader/lib/loader.js!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/common/FutureBets.vue
// module id = 306
// module chunks = 0